export default __webpack_public_path__ + "static/media/archiscan_module.401b205d.svg";